export class VueHelpers {
    constructor() {
        this.updateQueryString = function (name, value, remove = false) {
            if ('URLSearchParams' in window) {
                var searchParams = new URLSearchParams(window.location.search);
                if (!remove) {
                    searchParams.set(name, value);

                } else {
                    searchParams.delete(name);
                }
                const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
                window.history.pushState({ path: updatedUrl }, '', updatedUrl);
            }
        };

        this.clearQueryString = function () {
            if (window.location.search != "") {
                const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.pushState({ path: updatedUrl }, '', updatedUrl);
            }
        };

        this.getTimeDifferenceInSeconds = function (timestamp) {
            return Math.round(Date.now() / 1000) - Math.round(timestamp);
        };

        this.getTimestampInSeconds = function () {
            return Math.round(Date.now() / 1000);
        }

        this.getAntiForgeryToken = function () {
            return document.querySelector('input[name="__RequestVerificationToken"]').value;
        }
    }
};
export default new VueHelpers();